class GriExtraClass {
  constructor(config = {}) {
    const {
      griClassSelector
    } = config;
/*    console.log(griClassSelector)*/
    this.spansWithTopCLass = document.querySelectorAll(griClassSelector);
/*    console.log(this.spansWithTopCLass)*/
    if (this.spansWithTopCLass.length > 0) {
      this.addClass();
    }
  }

  addClass() {
    this.spansWithTopCLass.forEach((td) => {
      td.parentElement.parentElement.classList.add('ns-vertical-top');
    })
  }
}

export default GriExtraClass;
